// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"bdc08db7","304":"698064ef","611":"3f131662","649":"5b063c87","780":"56ce48e3","828":"a01f6bbd"}[chunkId] + ".chunk.js";
};